module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "testimonialWrapper pt-3"
  }, [_vm._m(0), _vm._v(" "), _c('carousel', {
    staticClass: "exc-cat-carousel",
    class: _vm.isDesktop ? 'pb-4' : 'pb-3',
    attrs: {
      "per-page": 1,
      "loop": true,
      "mouse-drag": true,
      "autoplay": true,
      "autoplayTimeout": 3000,
      "paginationActiveColor": "#000",
      "paginationColor": "#979a9f",
      "paginationSize": 7,
      "paginationPadding": _vm.isDesktop ? 5 : 3
    }
  }, _vm._l((this.testimonials), function(value, index) {
    return _c('slide', {
      key: index,
      staticClass: "exc-cat-slider"
    }, [_c('svg', {
      staticClass: "cls-22",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": _vm.isDesktop ? 28 : 21,
        "height": "88",
        "viewBox": "0 0 28 88"
      }
    }, [_c('text', {
      staticClass: "cls-1",
      attrs: {
        "id": "_",
        "data-name": "\"",
        "transform": "translate(14 63)"
      }
    }, [_c('tspan', {
      attrs: {
        "x": "-13.237",
        "y": "0"
      }
    }, [_vm._v("\"")])])]), _vm._v(" "), _c('div', {
      staticClass: "ratingsWrap"
    }, _vm._l((5), function(index) {
      return _c('span', {
        key: index
      }, [(index <= value.rating) ? _c('svg', {
        staticClass: "pr-2",
        attrs: {
          "xmlns": "http://www.w3.org/2000/svg",
          "width": _vm.isDesktop ? 27.624 : 21.624,
          "height": "26.267",
          "viewBox": "0 0 27.624 26.267"
        }
      }, [_c('path', {
        staticClass: "clr-1",
        attrs: {
          "id": "Path_286",
          "data-name": "Path 286",
          "d": "M13.808,0l4.27,8.648,9.545,1.388-6.908,6.731,1.633,9.5-8.541-4.485L5.275,26.267l1.633-9.5L0,10.036,9.545,8.648Z"
        }
      })]) : _c('svg', {
        staticClass: "pr-2",
        attrs: {
          "xmlns": "http://www.w3.org/2000/svg",
          "width": _vm.isDesktop ? 27.624 : 21.624,
          "height": "26.267",
          "viewBox": "0 0 27.624 26.267"
        }
      }, [_c('path', {
        staticClass: "clr-2",
        attrs: {
          "id": "Path_286",
          "data-name": "Path 286",
          "d": "M13.808,0l4.27,8.648,9.545,1.388-6.908,6.731,1.633,9.5-8.541-4.485L5.275,26.267l1.633-9.5L0,10.036,9.545,8.648Z"
        }
      })])])
    })), _vm._v(" "), _c('div', {
      staticClass: "funFactsSeq"
    }, [_c('span', {
      staticClass: "funfactComment",
      domProps: {
        "innerHTML": _vm._s(value.comment)
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "600",
        "color": "#494c63"
      },
      style: (_vm.isDesktop ? 'font-size: 26px;' : 'font-size: 0.9rem;'),
      domProps: {
        "innerHTML": _vm._s(value.commentBy)
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "cls-23",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": _vm.isDesktop ? 28 : 21,
        "height": "88",
        "viewBox": "0 0 28 88"
      }
    }, [_c('text', {
      staticClass: "cls-1",
      attrs: {
        "id": "_",
        "data-name": "\"",
        "transform": "translate(14 63)"
      }
    }, [_c('tspan', {
      attrs: {
        "x": "-13.237",
        "y": "0"
      }
    }, [_vm._v("\"")])])])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cl2"
  }, [_c('b', [_vm._v("TESTIMONIALS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c4ba10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TestimonialsSlider.vue
// module id = 2484
// module chunks = 26